export function getIgnoredWebVitals(browser: object): 'cls'[] {
  const supportsLayoutShiftSources =
    'LayoutShift' in browser &&
    typeof browser.LayoutShift === 'function' &&
    'sources' in browser.LayoutShift.prototype;

  return supportsLayoutShiftSources ? [] : ['cls'];
}
